import { scaleText } from "../lib/format";
import type { PrepAheadItem } from "../lib/types";

// GET A HEAD START — the jobs you can do a day or two before you cook.
//
// It sits ABOVE the steps on purpose: knowing you could have mixed the spice
// rub on Sunday is worthless if you read it on Wednesday at the stove. Amounts
// in the prose scale with the servings stepper, same as steps do, so "mix 2 tsp
// paprika" stays honest when you double the recipe.
export function PrepAhead({
  items,
  ratio = 1,
}: {
  items?: PrepAheadItem[];
  ratio?: number;
}) {
  const list = (items ?? []).filter((p) => p.title || p.text);
  if (list.length === 0) return null;

  return (
    <div className="prep-ahead">
      <div className="prep-ahead-head">
        <span className="eb">GET A HEAD START</span>
        <span className="eb prep-ahead-count">
          {list.length} JOB{list.length === 1 ? "" : "S"}
        </span>
      </div>
      <div className="prep-ahead-lede serif-italic">
        None of this needs the day you're cooking.
      </div>
      <ul className="prep-ahead-list">
        {list.map((p, i) => (
          <li key={i} className="prep-ahead-item">
            <div className="prep-ahead-title-row">
              {p.title && <span className="prep-ahead-title">{p.title}</span>}
              {p.when && <span className="prep-ahead-when">{p.when}</span>}
            </div>
            {p.text && <div className="prep-ahead-text">{scaleText(p.text, ratio)}</div>}
            {p.storage && (
              <div className="prep-ahead-storage">
                <span aria-hidden="true">⌂</span> {p.storage}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
